var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSearchActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.179,
    cy: 11.2492,
    rx: 11.179,
    ry: 11.2492,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.2771 25.9419C23.8428 25.9278 23.4299 25.7491 23.121 25.4416L20.4737 22.3472C19.9061 21.8282 19.8597 20.946 20.3696 20.3696C20.6083 20.1281 20.9329 19.9922 21.2714 19.9922C21.6099 19.9922 21.9344 20.1281 22.1731 20.3696L25.5025 23.0336C25.9821 23.5244 26.1301 24.2531 25.8803 24.894C25.6306 25.5348 25.0298 25.9681 24.3464 26L24.2771 25.9419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSearchActive);
export default __webpack_public_path__ + "static/media/footer_search_active.e6989411f09e7fda7106d5b05247705d.svg";
export { ForwardRef as ReactComponent };